import React, { useEffect, useState } from "react";
import { reApi } from "@/lib/residentApi";

/** The 10 weekly check-in questions inside the staff form: the specialist asks the resident and taps the answer they give. */
export default function CheckinQuestions({ seed, onChange }) {
  const [d, setD] = useState(null);
  const [ans, setAns] = useState(() => Object.fromEntries((seed?.answers || []).map((a) => [a.no, a.option])));
  useEffect(() => { reApi.get("/checkin-questions").then(setD).catch(() => setD(null)); }, []);
  useEffect(() => {
    const list = Object.entries(ans).map(([no, option]) => ({ no: Number(no), option }));
    onChange(list.length === 10 ? { answers: list } : {});
  }, [ans]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const n = Object.keys(ans).length;
  return (
    <section data-testid="re-ck-questions" className="space-y-3 border border-white/10 rounded-sm p-3">
      <div className="flex items-center justify-between">
        <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-gold">Check-in questions · ask the resident</div>
        <span data-testid="re-ck-questions-count" className={`font-mono text-[10px] ${n === 10 ? "text-emerald-300" : n ? "text-amber-300" : "text-nex-muted"}`}>
          {n}/10 answered{n > 0 && n < 10 ? " · finish all 10 to save them" : ""}
        </span>
      </div>
      {seed && <p data-testid="re-ck-questions-seed" className="text-[11px] text-nex-muted">Pre-filled from the answers {seed.source === "staff" ? "recorded" : "the resident gave on their portal"} on {seed.submitted_at.slice(0, 10)} — change any that are different now.</p>}
      <div className="grid gap-3 md:grid-cols-2">
        {d.questions.map((q) => (
          <div key={q.no} data-testid={`re-ck-q-${q.no}`} className="space-y-1.5">
            <div className="text-[10px] uppercase tracking-[0.16em] text-nex-muted">{d.groups[q.group]} · {q.no}</div>
            <div className="text-sm text-nex-silver">{q.prompt}</div>
            <div className="flex flex-col gap-1">
              {q.options.map((o) => (
                <button key={o.id} type="button" onClick={() => setAns({ ...ans, [q.no]: o.id })} data-testid={`re-ck-q-${q.no}-${o.id}`} aria-pressed={ans[q.no] === o.id}
                  className={`text-left text-xs px-2 py-1.5 border rounded-sm transition-colors ${ans[q.no] === o.id ? "border-nex-gold bg-nex-gold/10 text-nex-silver" : "border-white/10 text-nex-muted hover:border-white/30"}`}>{o.text}</button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
